module.exports = __webpack_public_path__ + "img/bio-10.dc3265e8.jpg";